import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { markdownToHtml } from '$lib/markdown';
import STEP from '$components/review/step';
import styles from './styles.scss';

const PassageChooseSentence = ({ handleChoice, quizState, quizObj }) => {
  const { quiz } = quizObj;
  const { evaluated, input } = quiz;
  const { choices } = evaluated;
  const { step } = quizState;

  return (
    <div className={styles.layout}>
      {choices.map((choice) => {
        const { uuid, markdown } = choice;

        const selectedUuid = _.get(input, 's', null);
        const isSelected = choice.uuid === selectedUuid;

        const classes = classnames(styles.choice, [
          styles.passagePiece,
          step === STEP.quizPrompt && styles.stepQuizPrompt,
          step === STEP.quizPrompt && isSelected && ['aaaSelected', styles.selected],
          step === STEP.quizConfirmation &&
            choice.correct && ['aaaCorrect', styles.correct],
          step === STEP.quizConfirmation &&
            !choice.correct &&
            isSelected && ['aaaIncorrect', styles.incorrect],
          step === STEP.quizConfirmation &&
            choice.correct &&
            !isSelected &&
            styles.highlight,
        ]);

        return (
          <div key={uuid} className={classes} onClick={() => handleChoice({ choice })}>
            {markdownToHtml(markdown)}
          </div>
        );
      })}
    </div>
  );
};

export default PassageChooseSentence;
